import React, {} from 'react';
export var ParentTheme;
(function (ParentTheme) {
    ParentTheme["LIGHT"] = "parent-light";
})(ParentTheme || (ParentTheme = {}));
/** The root of every screen: scopes the theme's tokens, page background, font and text color. Mount it once. */
export function ThemeProvider({ theme, children }) {
    return React.createElement("div", { "data-naru-theme": theme }, children);
}
//# sourceMappingURL=ThemeProvider.js.map